module.exports = __webpack_public_path__ + "img/76.8.TSS.81507bdf.png";